export default __webpack_public_path__ + "static/media/showcase-calendar.59e71718.jpg";